import { render } from "./secondaryNav.vue?vue&type=template&id=232e2a62&scoped=true"
import script from "./secondaryNav.vue?vue&type=script&lang=js"
export * from "./secondaryNav.vue?vue&type=script&lang=js"

import "./secondaryNav.vue?vue&type=style&index=0&id=232e2a62&lang=scss&scoped=true"

import exportComponent from "/Users/simongustafson/projekt/triathlon/triathlon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e2a62"]])

export default __exports__